import React, { useEffect, useRef, useState } from 'react';
import {
  Cross,
  DeleteMeetingIcon, EditMeetingIcon, HidePasswordIcon,
  MeetingViewModel,
  MessageDialogViewModel
} from '@components';
import { isCanEditMeeting, useOutsideClick, useStore, useViewModel } from '@utils';
import { CalendarViewModel, ProfileViewModel } from '@views';
import { observer } from 'mobx-react-lite';
import { RoomsStore } from '../../../store';
import { MeetingDetailedInformation } from './MeetingDetailedInformation';
import '../../../styles/components/meetingDetailedInformationModal.scss';

export const MeetingDetailedInformationModal = observer(() => {
  const meetingViewModel = useViewModel(MeetingViewModel);
  const profileViewModel = useViewModel(ProfileViewModel);
  const calendarViewModel = useViewModel(CalendarViewModel);
  const messageDialogService = useViewModel(MessageDialogViewModel);
  const roomsStore = useStore(RoomsStore);
  const contentRef = useRef<HTMLDivElement>();
  const [isScrollable, setIsScrollable] = useState(false);

  useEffect(() => {
    contentRef.current && setIsScrollable(contentRef.current.scrollHeight !== contentRef.current.clientHeight);
  }, [contentRef?.current?.scrollHeight]);

  const openMeetingModal = () => {
    meetingViewModel.setIsOpenedFromFilterPage(false);
    meetingViewModel.initMeeting(meetingViewModel.moreMeetingInformation);
    !roomsStore.data.length && roomsStore.getRooms();
    meetingViewModel.closeMoreMeetingInformationModal();
  };

  const openMeetingEditModal = () => {
    meetingViewModel.setEditable(true);
    openMeetingModal();
  };

  const openMeeting = () => {
    meetingViewModel.setEditable(false);
    openMeetingModal();
  };

  const onDeleteMeeting = () => {
    meetingViewModel.deleteMeeting(meetingViewModel.moreMeetingInformation.id)
      .then(() => {
        meetingViewModel.closeMoreMeetingInformationModal();
        calendarViewModel.getAllMeetings();
      });
  };

  const openConfirm = () => {
    closeModal();
    if (meetingViewModel.moreMeetingInformation.intervalType === 'WITHOUT_REPEAT') {
      messageDialogService.open({
        message: 'Вы уверены, что хотите удалить?',
        onAccept: onDeleteMeeting,
      });
    } else {
      messageDialogService.openChange(true);
    }
  };

  const closeModal = () =>
    meetingViewModel.closeMoreMeetingInformationModal();

  const modalRef = useOutsideClick(closeModal);

  const top = meetingViewModel.popupCoordinates.showTop ? meetingViewModel.popupCoordinates.top - 210
    : meetingViewModel.popupCoordinates.top;
  const left = meetingViewModel.popupCoordinates.showLeft ? meetingViewModel.popupCoordinates.left - 402
    : meetingViewModel.popupCoordinates.left;

  return (
    <div
      className="modal"
      ref={modalRef}
      style={{ top, left }}
    >
      <div className="button-row">
        {isCanEditMeeting(meetingViewModel.moreMeetingInformation) && meetingViewModel.moreMeetingInformation.id !== -1 && (
          <>
            <EditMeetingIcon divClassName="modal-button icon" onClick={openMeetingEditModal} />
            <DeleteMeetingIcon divClassName="modal-button icon" onClick={openConfirm} />
          </>
        )}
        <HidePasswordIcon divClassName="modal-button icon" onClick={openMeeting} />
        <Cross divClassName="modal-button icon" onClick={closeModal} />
      </div>
      <div
        className="content"
        ref={contentRef}
        style={{
          paddingRight: isScrollable ? 10 : 'auto',
        }}
      >
        <MeetingDetailedInformation 
          meeting={meetingViewModel.moreMeetingInformation} 
          offset={profileViewModel.minutesOffset}
        />
      </div>
    </div>
  );
});
